var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "-5 -5 12.8 9.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Flag of the People&apos;s Republic of China\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    fill: "#ffde00",
    d: "M-.588.81L0-1 .588.81-.952-.31H.952z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-15.4h26.667v20H-5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48 0 0 .48 -2.6 2.39)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de2910",
    d: "M-5-15.4h30v20H-5z"
  }), /*#__PURE__*/React.createElement("use", {
    height: 20,
    width: 30,
    transform: "matrix(3 0 0 3 0 -10.4)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    height: 20,
    width: 30,
    transform: "rotate(-120.93 -1.29 -8.12)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    height: 20,
    width: 30,
    transform: "rotate(-98.11 -1.45 -8.74)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    height: 20,
    width: 30,
    transform: "rotate(-74.04 -2.07 -8.84)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    height: 20,
    width: 30,
    transform: "rotate(-51.32 -4.16 -8.4)",
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.0afbda3c9fa13d339d53512831d9b8c5.svg";
export { ForwardRef as ReactComponent };